function initializeCustomJS(cartWasUpdated) {
  const body = document.body;
  const header = document.querySelector('header');
  const blackLogo = document.querySelector('.black-logo');
  const whiteLogo = document.querySelector('.white-logo');
  const footer = document.querySelector('.footer');
  const sectionFooter = document.querySelector('.section-footer');
  const toggleMenu = document.getElementById('toggle-menu');
  const links = document.querySelectorAll('ul.menu-links li');
  const mobileLinks = document.querySelectorAll('li.has-submenu');
  const closeSubmenuBtn = document.querySelectorAll('.close-submenu');
  const megaMenu = document.querySelector('.menu-modal');
  const modalPosition = megaMenu ? megaMenu.querySelector('.modal-position') : null;
  const closeIcon = megaMenu ? megaMenu.querySelector('.close-icon') : null;
  const modelContent = megaMenu ? megaMenu.querySelector('.model-content') : null;
  const headerIconRight = document.querySelector('.icon-right');
  const megaMenuInnerList = document.querySelectorAll('.mega-menu-inner');
  const closeMegamenu = document.querySelector('.close-icon__mega-menu');
  const currencySwitcher = document.querySelectorAll('.currency-switcher');
  const countryList = document.querySelectorAll('.currency-switcher li');
  const switcherModal = document.getElementById('switcher-modal');
  const closeSwitcher = document.querySelector('.close-switcher');
  const countryCode = document.getElementById('country_code');
  const mainContent = document.getElementById('MainContent');
  const notify = document.querySelector('.notify');
  const wishlistIcon = document.querySelectorAll('.wishlist-icon');
  const wishListIconHeader = document.querySelector('.hulk-sidebar-widget');
  const badges = document.querySelectorAll('.badge-inverted');
  const wishlist = document.querySelector('.wishlist');
  const wishlistClose = document.querySelectorAll('.wishlist__close');
  const miniBagYouMayAlsoLikeSection = document.getElementById('mini-bag-you-may-also-like-section');
  const cartYouMayAlsoLikeSection = document.getElementById('cart-you-may-also-like-section');
  const klevuQuickSearchTheme = document.querySelector('.klevu-quick-search-theme');
  const megaMenuContent = document.querySelectorAll('.mega-menu-left');
  const miniCartCustomContent = document.querySelector('.cart-custom-content');
  const openMiniCart = document.querySelector('open-mini-cart');

  const hamburger = document.querySelectorAll('.hamburger');
  const allHamburgerDrawer = document.querySelectorAll('.hamburger__drawer');
  const hamburgerMenu = document.querySelector('.hamburger__menu');
  const hamburgerMenuReverted = document.querySelectorAll('.hamburger__menu-reverted');
  const toggleHamburger = document.querySelectorAll('.toggle-hamburger');

  const accountIcon = document.querySelectorAll('.account-icon');
  const signIn = document.querySelector('.sign-in');
  const signInClose = document.querySelectorAll('.sign-in__close');

  const miniBagIcon = document.querySelectorAll('.mini-bag-icon');
  const miniBag = document.querySelector('.min-bag-drawer');
  const miniBagClose = document.querySelectorAll('.min-bag-drawer__close');
  const searchIcon = document.querySelectorAll('.search-icon');
  const search = document.querySelector('.search');
  const searchClose = document.querySelectorAll('.search__close');

  const klevuSearchInput = document.querySelector('.klevu-input');

  const tabDrawer = document.querySelector('.tab-drawer');
  const tabDrawerClose = tabDrawer ? tabDrawer.querySelectorAll('.tab-drawer__close') : [];
  const tabItems = document.querySelectorAll('.tab-ul li');
  const scrollProgress = document.querySelector('.tab-drawer__progress-bar');
  const personalisedScrollProgress = document.querySelector('.personalised-drawer__progress-bar');
  const personalisedDrawer = document.querySelector('.personalised-drawer');
  const personalisedDrawerClose = personalisedDrawer
    ? personalisedDrawer.querySelectorAll('.personalised-drawer__close')
    : [];
  const personalisedButton = document.querySelectorAll('.personalised__button');
  const variantId = personalisedDrawer ? personalisedDrawer.dataset.variantId : null;
  const cartHasBeenUpdated = cartWasUpdated;

  let lastScrollTop = 0;
  let isOpen = false;
  let lastComponentName = '';

  function addClass(element, ...classNames) {
    if (element) element.classList.add(...classNames);
  }

  function removeClass(element, ...classNames) {
    if (element) element.classList.remove(...classNames);
  }

  function replaceClass(element, oldClassName, newClassName) {
    if (element) element.classList.replace(oldClassName, newClassName);
  }

  function checkDevice() {
    const userAgent = navigator.userAgent;
    const isMobile = /iPhone|Android.*Mobile/i.test(userAgent);
    const isTablet = /iPad|Tablet|Android(?!.*Mobile)/i.test(userAgent);
    const isTouchEnabled = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;

    if (isMobile) {
      body.classList.add('device-mobile');
    } else if (isTablet || isTouchEnabled) {
      body.classList.add('device-tablet');
    } else {
      body.classList.add('device-desktop');
    }

    document.dispatchEvent(new CustomEvent('DeviceDetected'));
  }

  checkDevice();

  function applyBadgeStyles(classes, func) {
    badges.forEach((badge) => {
      func(badge, classes);
    });
  }

  function getScrollTriggerPosition() {
    let scrollTrigger;
    if (window.innerWidth < 1024) {
      scrollTrigger = 72;
    } else if (window.innerWidth < 1512) {
      scrollTrigger = 90;
    } else {
      scrollTrigger = 108;
    }
    return scrollTrigger;
  }

  function styleHeaderScrollUp() {
    applyBadgeStyles('scroll-up-badge-style', addClass);
    addClass(wishListIconHeader, '!text-grey-1000');

    if (header.classList.contains('header-inverted')) {
      hamburgerMenuReverted.forEach((menuBar) => {
        replaceClass(menuBar, 'bg-grey-0', 'bg-grey-1000');
      });
    }
  }

  function styleHeaderScrolledToTop() {
    addClass(wishListIconHeader, '!text-grey-1000');
    replaceClass(header, 'h-spacing-5xl', 'md:h-108');

    if (blackLogo){
      replaceClass(blackLogo, 'md:w-spacing-xl', 'md:w-spacing-4xl');
      replaceClass(blackLogo, 'md:h-39', 'md:h-68.25');
    }

    if (whiteLogo){
      replaceClass(whiteLogo, 'md:w-spacing-xl', 'md:w-spacing-4xl');
      replaceClass(whiteLogo, 'md:h-39', 'md:h-68.25');
    }
  }

  function styleInvertedHeaderScrolledToTop() {
    const styleInvertedWishlistIcon =
      !header.classList.contains('template-collection') && !header.classList.contains('template-search');

    addClass(header, 'h-spacing-5xl', 'md:h-108');

    if (styleInvertedWishlistIcon) {
      replaceClass(wishListIconHeader, '!text-grey-1000', '!text-grey-0');
      applyBadgeStyles('scroll-up-badge-style', removeClass);
    }

    hamburgerMenuReverted.forEach((menuBar) => {
      replaceClass(menuBar, 'bg-grey-1000', 'bg-grey-0');
    });
  }
  function styleTransparentHeaderScrolledToTop() {
    addClass(header, 'h-spacing-5xl', 'md:h-108');
    replaceClass(wishListIconHeader, '!text-grey-0', 'text-grey-1000');
    applyBadgeStyles('scroll-up-badge-style', removeClass);
  }

  function handleScroll() {
    const currentScrollTop = window.scrollY;
    let scrollTrigger = getScrollTriggerPosition();

    if (body.classList.contains('header-white')) {
      addClass(body, 'white-bg');
    }

    if (currentScrollTop > lastScrollTop) {
      // Scrolling down
      if (blackLogo){
        replaceClass(blackLogo, 'md:w-spacing-4xl', 'md:w-spacing-xl');
        replaceClass(blackLogo, 'md:h-68.25', 'md:h-39')
      }

      if (whiteLogo) {
        replaceClass(whiteLogo, 'md:w-spacing-4xl', 'md:w-spacing-xl');
        replaceClass(whiteLogo, 'md:h-68.25', 'md:h-39');
      }

      replaceClass(header, 'md:h-108', 'h-spacing-5xl')
    } else {
      if (currentScrollTop <= scrollTrigger) {
        //Scrolled to top of page
        styleHeaderScrolledToTop(); 
      } else {
        // Scrolling up
        styleHeaderScrollUp();
      }

      if (currentScrollTop >= 0 && currentScrollTop <= scrollTrigger) {
        if (header.classList.contains('header-inverted')) {
          styleInvertedHeaderScrolledToTop();
        }
        if (header.classList.contains('header-transparent') && !header.classList.contains('template-search')) {
          styleTransparentHeaderScrolledToTop();
        }
      }
    }
    lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
  }

  function debounce(func, wait) {
    let timeout;
    return function (...args) {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
    };
  }

  window.addEventListener('scroll', debounce(handleScroll, 10));

  function updateLogoStyling() {
    if (!header.classList.contains('scroll-up-header') && header.classList.contains('header-inverted')) {
      if (whiteLogo) {
        replaceClass(whiteLogo, 'opacity-1', 'opacity-0');
      }
      if (blackLogo) {
        replaceClass(blackLogo, 'opacity-0', 'opacity-1');
      }
    }
  }

  header.addEventListener('mouseenter', updateLogoStyling);

  function checkHeaderClasses() {
    const headerIsInverted =
      header.classList.contains('header-inverted') &&
      !header.classList.contains('scroll-up-header') &&
      !header.classList.contains('template-collection') &&
      !header.classList.contains('template-search');

    if (header.classList.contains('header-transparent') || headerIsInverted) {
      applyBadgeStyles('is-transparent', addClass);
    }
    if (headerIsInverted) {
      addClass(wishListIconHeader, 'wishlist-icon-inverted', '!text-grey-0');
      removeClass(wishListIconHeader, '!text-grey-1000');
    }
  }
  checkHeaderClasses();

  function handleToggleMenu() {
    body.classList.toggle('hamburger-menu-opened');
    body.classList.add('fixed', 'w-full');
    header.classList.add('!fixed', '!translate-y-0');
    if (header) header.classList.toggle('mobile-menu-opened');
    if (!header.classList.contains('mobile-menu-opened')) {
      removeClass(header, '!fixed', '!translate-y-0');
      removeClass(body, 'fixed', 'w-full');
    }
    handleBadgeColoursMobile();
  }

  function handleBadgeColoursMobile() {
    if (header.classList.contains('header-transparent') || header.classList.contains('header-inverted')) {
      badges.forEach((badge) => {
        if (header.classList.contains('hamburger-menu-opened') || header.classList.contains('mobile-menu-opened')) {
          replaceClass(badge, 'is-transparent', '!text-grey-1000');
        } else {
          replaceClass(badge, '!text-grey-1000', 'is-transparent');
        }
      });
    }
  }

  function handleMegaMenu(linkAttrId) {
    if (isOpen && megaMenu.classList.contains('menu-opened')) {
      if (megaMenu.id === linkAttrId) {
        closeMenu();
        return;
      } else {
        toggleMegaMenus(linkAttrId);
        return;
      }
    } else {
      openMenu();
      toggleMegaMenus(linkAttrId);
    }
  }

  function toggleMegaMenus(clickedId) {
    megaMenuInnerList.forEach((menu) => {
      if (menu.id === clickedId) {
        addClass(menu, 'active');
      } else {
        removeClass(menu, 'active');
      }
    });
  }

  function openMenu() {
    isOpen = true;
    addClass(megaMenu, 'menu-opened');
    removeClass(megaMenu, 'opacity-0', 'pointer-events-none');
    removeClass(header, 'z-30');
    addClass(body, 'fixed', 'w-full');
    applyBadgeStyles('is-transparent', removeClass);
    removeClass(header, 'inverted');
    addClass(wishListIconHeader, '!text-grey-1000');
  }

  function closeMenu() {
    isOpen = false;
    removeClass(megaMenu, 'menu-opened');
    addClass(megaMenu, 'opacity-0', 'pointer-events-none');
    removeClass(header, '!fixed', '!translate-y-0');
    megaMenuInnerList.forEach((menu) => {
      removeClass(menu, 'active');
    });
    links.forEach((otherLink) => otherLink.classList.remove('active'));
    body.classList.remove('hamburger-menu-opened');
    if (header) header.classList.remove('mobile-menu-opened');
    handleCloseMegaMenu();
    checkBadgeColour();
    checkInvertedHeader();
  }

  function handleCloseMegaMenu() {
    removeClass(megaMenu, 'menu-opened');
    addClass(megaMenu, 'opacity-0', 'pointer-events-none');
    addClass(header, 'z-30');
    removeClass(body, 'fixed', 'w-full', 'right-mega-menu-opened', 'left-mega-menu-opened');
    addClass(body, 'sticky');
    replaceClass(header, 'absolute', 'sticky');   
    links.forEach((otherLink) => otherLink.classList.remove('active'));
    isOpen = false;
    megaMenuInnerList.forEach((menu) => {
      removeClass(menu, 'active');
    });
    megaMenuContent.forEach((item) => {
      addClass(item, 'hidden', 'w-0');
    });
    checkBadgeColour();
    checkInvertedHeader();
  }

  function handleMobileMenu() {
    const submenu = this.querySelector('.submenu');
    if (!this.classList.contains('opened')) {
      addClass(this, 'opened');
      removeClass(submenu, '-z-10', 'opacity-0', 'translate-x-30', 'pointer-events-none');
      addClass(submenu, 'translate-x-0');
      removeClass(hamburgerMenu, 'h-auto');
      addClass(hamburgerMenu, 'submenu-opened');
      hamburger.forEach((burger) => {
        addClass(burger, 'overflow-y-hidden');
      });
    }
  }

  function handleCloseSubmenu(event) {
    const submenu = this.closest('div.submenu');
    this.closest('li.opened').classList.remove('opened');
    addClass(submenu, '-z-10', 'opacity-0', 'translate-x-30', 'pointer-events-none');
    removeClass(submenu, 'translate-x-0');
    addClass(hamburgerMenu, 'h-auto');
    removeClass(hamburgerMenu, 'submenu-opened');
    hamburger.forEach((burger) => {
      removeClass(burger, 'overflow-y-hidden');
    });
    event.stopPropagation();
  }

  function handleCurrencySwitcher() {
    if (this.classList.contains('max-h-10')) {
      addClass(this, 'max-h-260', 'rounded-t', 'active');
      removeClass(this, 'max-h-10', 'rounded');
    } else {
      removeClass(this, 'max-h-260', 'rounded-t', 'active');
      addClass(this, 'max-h-10', 'rounded');
    }
    this.classList.toggle('bg-grey-0');
  }

  function adjustMargin() {
    if (window.innerWidth > 1200) {
      addClass(footer.parentNode, 'lg:sticky', 'lg:bottom-0', 'lg:-z-10');
    } else {
      removeClass(footer.parentNode, 'lg:sticky', 'lg:bottom-0', 'lg:-z-10');
    }
  }

  if (footer) {
    adjustMargin();
  }

  function closeFollowMousePosition() {
    // Check if the body has the class 'device-desktop'
    if (!document.body.classList.contains('device-desktop')) {
      return;
    }

    const closeContainers = document.querySelectorAll('.close-container');
    if (closeContainers) {
      closeContainers.forEach((container) => {
        const closeButton = container.querySelector('.close-button');
        let isMouseInside = false;

        container.addEventListener('mouseenter', () => {
          isMouseInside = true;
        });

        container.addEventListener('mouseleave', () => {
          isMouseInside = false;
        });

        document.addEventListener('mousemove', (e) => {
          if (isMouseInside) {
            const rect = container.getBoundingClientRect();
            const x = Math.max(0, Math.min(e.clientX - rect.left, rect.width));
            const y = Math.max(0, Math.min(e.clientY - rect.top, rect.height));
            closeButton.style.position = 'absolute';
            closeButton.style.left = `${x}px`;
            closeButton.style.top = `${y}px`;
            closeButton.style.opacity = '100';
          } else {
            closeButton.style.opacity = '0';
          }
        });
      });
    }
  }

  closeFollowMousePosition();

  window.addEventListener('resize', function () {
    if (footer) {
      adjustMargin();
    }
  });

  if (links) {
    links.forEach((link) => {
      link.addEventListener('click', (e) => {
        megaMenuContent.forEach((item) => {
          removeClass(item, 'hidden', 'w-0');
        });

        const linkAttrId = link.getAttribute('data-attrid');
        const parentUlId = link.closest('ul').id;
        if (parentUlId == 'left-links') {
          addClass(modalPosition, 'left-0');
          addClass(body, 'left-mega-menu-opened');
          removeClass(body, 'right-mega-menu-opened');
          replaceClass(closeIcon, 'justify-start', 'justify-end');
          removeClass(closeIcon, 'order-1');
          removeClass(modelContent, 'justify-end', 'order-2');
        } else {
          if (modalPosition.classList.contains('left-0')) {
            removeClass(modalPosition, 'left-0');
            removeClass(body, 'left-mega-menu-opened');
            addClass(modalPosition, 'right-0');
            addClass(body, 'right-mega-menu-opened');
            replaceClass(closeIcon, 'justify-end', 'justify-start');
            addClass(closeIcon, 'order-1');
            addClass(modelContent, 'justify-end', 'order-2');
            headerIconRight.classList.toggle('z-30');
          } else {
            removeClass(body, 'left-mega-menu-opened');
            addClass(body, 'right-mega-menu-opened');
            addClass(modalPosition, 'right-0');
            replaceClass(closeIcon, 'justify-end', 'justify-start');
            addClass(closeIcon, 'order-1');
            addClass(modelContent, 'justify-end', 'order-2');
            headerIconRight.classList.toggle('z-30');
          }
        }

        if (link.classList.contains('has-mega-menu')) {
          removeClass(body, 'sticky');
          replaceClass(header, 'sticky', 'absolute');

          if (link.classList.contains('active') && !cartHasBeenUpdated) {
            link.classList.remove('active');
            closeMenu();
          } else {
            links.forEach((otherLink) => otherLink.classList.remove('active'));
            if (!cartHasBeenUpdated) {
              link.classList.add('active');
              handleMegaMenu(linkAttrId, link);
            }
          }
        } else {
          closeMenu();
          links.forEach((otherLink) => otherLink.classList.remove('active'));
        }
      });
    });
  }

  if (closeMegamenu) {
    closeMegamenu.addEventListener('click', handleCloseMegaMenu);
  }

  if (mobileLinks) {
    mobileLinks.forEach((link) => {
      link.addEventListener('click', handleMobileMenu);
    });
  }

  if (closeSubmenuBtn) {
    closeSubmenuBtn.forEach((link) => {
      link.addEventListener('click', handleCloseSubmenu);
    });
  }

  if (toggleMenu) {
    toggleMenu.addEventListener('click', handleToggleMenu);
  }

  if (currencySwitcher) {
    currencySwitcher.forEach((currency) => {
      currency.addEventListener('click', handleCurrencySwitcher);
    });
  }

  if (closeSwitcher) {
    const switcherHead = document.querySelector('.popup-head');
    const switcherDesc = document.querySelector('.popup-desc');
    const confirmationSwitcherButton = document.querySelector('.confirmation-button');
    const closeSwitcherButton = document.querySelector('.close-switcher');

    closeSwitcher.addEventListener('click', function () {
      switcherHead.classList.add('hidden');
      switcherDesc.innerHTML =
        'When switching countries your shopping bag will be emptied. Are you sure you want to proceed?';
      confirmationSwitcherButton.innerHTML = 'continue';
      closeSwitcherButton.innerHTML = 'cancel';
      addClass(switcherModal, 'hidden');
      removeClass(switcherModal, 'flex');
      removeClass(header, '!fixed', '!translate-y-0');
      adjustMargin();
    });
  }

  if (countryList) {
    countryList.forEach((link, index) => {
      link.addEventListener('click', function () {
        if (!link.classList.contains('current')) {
          const linkValue = link.getAttribute('value');
          if (switcherModal.classList.contains('hidden')) {
            countryCode.value = linkValue;
            removeClass(switcherModal, 'hidden');
            addClass(switcherModal, 'flex');
            addClass(header, '!fixed', '!translate-y-0');
            adjustMargin();
          }
        }
      });
    });
  }

  if (openMiniCart) {
    openMiniCart.addEventListener('click', function (event) {
      event.preventDefault();
    });
  }

  function openModal(element) {
    applyBadgeStyles('is-transparent', removeClass);
    removeClass(header, 'inverted');
    addClass(wishListIconHeader, '!text-grey-1000');
    addClass(element, 'menu-opened');
    removeClass(element, 'opacity-0', 'pointer-events-none');
    addClass(header, '!fixed', '!translate-y-0');
  }

  function closeModal(element) {
    checkInvertedHeader();
    removeClass(element, 'menu-opened');
    addClass(element, 'opacity-0', 'pointer-events-none');
    removeClass(header, '!fixed', '!translate-y-0');
    if (body.style.overflow === 'hidden') {
      body.style.overflow = '';
    }
    checkBadgeColour();
  }

  function closeAllModals() {
    closeModal(miniBag);
    closeModal(signIn);
    closeModal(search);
    closeModal(wishlist);
    closeMenu();
  }

  if (accountIcon) {
    accountIcon.forEach((icon) => {
      icon.addEventListener('click', function () {
        closeAllModals();
        openModal(signIn);
      });
    });
  }

  // Function to handle the click event on the mini bag icons
  const handleMiniBagClick = () => {
    // Close any currently open modals
    closeAllModals();

    miniCartCustomContent.classList.remove('w-0');

    // Open the mini cart modal
    openModal(miniBag);

    // Push an event to the dataLayer for analytics tracking
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'dl_mini_cart_open' });

    // Dispatch a custom event to update image sources (if needed)
    document.dispatchEvent(new CustomEvent('reUpdateImageSrc'));
  };

  // Add a click event listener to each mini bag icon
  miniBagIcon.forEach((icon) => {
    icon.addEventListener('click', handleMiniBagClick);
  });

  if (searchIcon) {
    searchIcon.forEach((icon) => {
      icon.addEventListener('click', function () {
        if (klevuSearchInput) {
          setTimeout(function () {
            klevuSearchInput.focus();
          }, 1000);
        }
        closeAllModals();
        klevuQuickSearchTheme.classList.remove('hidden');
        openModal(search);
        body.classList.add('fixed', 'w-full');
      });
    });
  }

  if (searchClose) {
    searchClose.forEach((close) => {
      close.addEventListener('click', function () {
        closeModal(search);
        handleBadgeColoursMobile();
        removeClass(body, 'fixed', 'w-full');
      });
    });
  }

  if (signInClose) {
    signInClose.forEach((close) => {
      close.addEventListener('click', function () {
        closeModal(signIn);
      });
    });
  }

  if (miniBagClose) {
    miniBagClose.forEach((close) => {
      close.addEventListener('click', function () {
        closeModal(miniBag);
        removeClass(body, 'fixed', 'w-full');

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'dl_mini_cart_close',
        });
        handleBadgeColoursMobile();
      });
    });
  }

  wishlistIcon.forEach((icon) => {
    icon.addEventListener('click', function () {
      closeAllModals();
      openModal(wishlist);
    });
  });

  wishlistClose.forEach((close) => {
    close.addEventListener('click', function () {
      closeModal(wishlist);
    });
  });

  function checkBadgeColour() {
    if (header.classList.contains('header-transparent') || header.classList.contains('header-inverted')) {
      applyBadgeStyles('is-transparent', addClass);
    }
  }

  function checkInvertedHeader() {
    if (!header.classList.contains('header-solid') && !header.classList.contains('header-transparent')) {
      addClass(header, 'inverted');
      removeClass(wishListIconHeader, '!text-grey-1000');
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    const modalDiv = document.getElementById('md-app-embed__modal');
    const formContentDiv = document.querySelector('.md-modal__formContent');
    const footerContentDiv = document.querySelector('.md-modal__footerContent');
    const closeButton = document.createElement('button');
    let isPopupClosed = localStorage.getItem('popupClosed');

    if (isPopupClosed) {
      removeClass(body, 'orbe--opened');
      if (modalDiv) {
        modalDiv.style.display = 'none';
      }
    }

    if (formContentDiv) {
      formContentDiv.style.display = 'none';
    }

    closeButton.setAttribute('type', 'button');
    closeButton.setAttribute('aria-label', 'Close');
    addClass(closeButton, 'md-modal-closeButton', 'md-modal-closeButtonAction');
    closeButton.textContent = 'Continue';

    if (footerContentDiv) {
      footerContentDiv.appendChild(closeButton);
      closeButton.addEventListener('click', function () {
        localStorage.setItem('popupClosed', 'true');
        removeClass(body, 'orbe--opened');
        if (modalDiv) {
          modalDiv.style.display = 'none';
        }
      });
    }
  });

  if (window.innerWidth > 1200) {
    window.addEventListener('scroll', function () {
      let scrollPos = window.scrollY;
      let contentHeight = mainContent.offsetHeight;
      let windowHeight = window.innerHeight;

      let startTransformPos = contentHeight - windowHeight;

      if (scrollPos >= startTransformPos) {
        let maxScroll = windowHeight;
        let scrollProgress = (scrollPos - startTransformPos) / maxScroll;
        let initialTranslatePercentage = 70;
        let newTranslatePercentage = initialTranslatePercentage - scrollProgress * initialTranslatePercentage;
        newTranslatePercentage = Math.max(0, Math.min(initialTranslatePercentage, newTranslatePercentage));
        sectionFooter.style.transform = 'translate(0%, ' + newTranslatePercentage + '%)';
      } else {
        sectionFooter.style.transform = 'translate(0%, 70%)';
      }
    });
  }

  const parallaxElements = document.getElementsByClassName('parallax');

  // Function to apply the smooth parallax effect based on scroll position
  function applySmoothParallax(scrollPosition) {
    const scrollValue = Math.min(scrollPosition * 0.16, 160);

    // Check if there are parallax elements to transform
    if (parallaxElements.length > 0) {
      Array.from(parallaxElements).forEach((element) => {
        element.style.transform = `translateY(${scrollValue}px)`;
      });
    }
  }

  window.addEventListener('scroll', () => {
    const currentScrollPosition = window.scrollY;

    // Only run the parallax effect if the screen width is 1024px or more
    if (window.matchMedia('(min-width: 1024px)').matches) {
      applySmoothParallax(currentScrollPosition);
    }
  });

  window.addEventListener('DOMContentLoaded', () => {
    if (header.classList.contains('bg-grey-0')) {
      addClass(body, 'header-white');
    }
  });

  if (window.innerWidth < 1024 && !cartHasBeenUpdated) {
    toggleHamburger.forEach((btn) => {
      btn.addEventListener('click', function () {
        let attrValue = this.getAttribute('data-component');
        let hamburgerDrawer = document.querySelector('.' + attrValue);

        allHamburgerDrawer.forEach((hamburger) => {
          if (!hamburger.classList.contains('opacity-0')) {
            addClass(hamburger, 'opacity-0', 'pointer-events-none');
          }
          removeClass(hamburger, 'active');
        });

        if (lastComponentName == '' || lastComponentName == attrValue) {
          handleToggleMenu();
        } else if (lastComponentName != attrValue && attrValue == 'hamburger__menu') {
          handleToggleMenu();
        } else if (
          lastComponentName == 'hamburger__menu' &&
          attrValue != 'hamburger__menu' &&
          !header.classList.contains('mobile-menu-opened')
        ) {
          handleToggleMenu();
        }

        removeClass(hamburgerDrawer, 'opacity-0', 'pointer-events-none');
        addClass(hamburgerDrawer, 'active');
        lastComponentName = attrValue;
      });
    });
  }

  if (tabDrawer) {
    const handleTabItemClick = function () {
      removeClass(header, 'hidden', 'md:flex');
      removeClass(personalisedDrawer, 'active');
      addClass(personalisedDrawer, 'translate-x-full', 'opacity-0');

      personalisedButton.forEach((tabItem) => removeClass(tabItem, 'active'));
      tabItems.forEach((tabItem) => {
        removeClass(tabDrawer, tabItem.getAttribute('data-component'));
        removeClass(tabItem, 'active');
      });

      const attrValue = this.getAttribute('data-component');
      addClass(this, 'active');
      addClass(tabDrawer, 'active', attrValue);
      removeClass(tabDrawer, 'translate-x-full', 'opacity-0');
    };

    const handleTabDrawerClose = function () {
      removeClass(tabDrawer, 'active');
      addClass(tabDrawer, 'translate-x-full', 'opacity-0');
      tabItems.forEach((tabItem) => removeClass(tabItem, 'active'));
    };

    const updateTabDrawerProgress = () => {
      const scroll = tabDrawer.scrollTop;
      const height = tabDrawer.scrollHeight - tabDrawer.clientHeight;
      const percent = (scroll / height) * 100;
      scrollProgress.style.height = percent + '%';
      scrollProgress.style.top = scroll + 'px';
    };

    tabItems.forEach((item) => item.addEventListener('click', handleTabItemClick));
    tabDrawerClose.forEach((item) => item.addEventListener('click', handleTabDrawerClose));
    tabDrawer.addEventListener('scroll', updateTabDrawerProgress);
  }

  if (personalisedDrawer) {
    const handlePersonalisedButtonClick = function () {
      const attrValue = this.getAttribute('data-component');

      removeClass(tabDrawer, 'active');
      addClass(tabDrawer, 'translate-x-full', 'opacity-0');
      tabItems.forEach((tabItem) => removeClass(tabItem, 'active'));

      removeClass(this, 'border-brand-red');

      personalisedButton.forEach((tabItem) => {
        removeClass(personalisedDrawer, tabItem.getAttribute('data-component'));
        removeClass(tabItem, 'active');
      });

      addClass(header, 'hidden', 'md:flex');
      addClass(this, 'active');
      addClass(personalisedDrawer, 'active', attrValue);
      removeClass(personalisedDrawer, 'translate-x-full', 'opacity-0');

      if (
        body.classList.contains('device-desktop') ||
        (body.classList.contains('device-tablet') && window.innerWidth >= 1024)
      ) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      }
    };

    const handlePersonalisedDrawerClose = function () {
      removeClass(header, 'hidden', 'md:flex');
      removeClass(personalisedDrawer, 'active');
      addClass(personalisedDrawer, 'translate-x-full', 'opacity-0');

      const getStorageKey = (key) => `${variantId}_${key}`;
      const line1 = localStorage.getItem(getStorageKey('line-1'));
      const line2 = localStorage.getItem(getStorageKey('line-2'));

      if (!line1 && !line2) {
        personalisedButton.forEach((item) => addClass(item, 'border-brand-red'));
      }
      personalisedButton.forEach((tabItem) => removeClass(tabItem, 'active'));
    };

    const updatePersonalisedDrawerProgress = () => {
      const scroll = personalisedDrawer.scrollTop;
      const height = personalisedDrawer.scrollHeight - personalisedDrawer.clientHeight;
      const percent = (scroll / height) * 100;
      personalisedScrollProgress.style.height = percent + '%';
      personalisedScrollProgress.style.top = scroll + 'px';
    };

    personalisedButton.forEach((item) => item.addEventListener('click', handlePersonalisedButtonClick));
    personalisedDrawerClose.forEach((item) => item.addEventListener('click', handlePersonalisedDrawerClose));
    personalisedDrawer.addEventListener('scroll', updatePersonalisedDrawerProgress);
  }

  if (notify) {
    const notifyButton = notify.getElementsByTagName('button');
    notifyButton[0].addEventListener('click', function (event) {
      if (event.target.nodeName == 'BUTTON') {
        let notifyLink = notifyButton[0].querySelector('.NBIS-Modal__btn');
        notifyLink.click();
      }
    });
  }

  (function initializeNotifyJs() {
    function checkAndAddBodyClass() {
      const escFormApp = document.querySelector('#esc-oos-form-app.NBIS-Modal__overlay');
      if (escFormApp && escFormApp.classList.contains('NBIS-Modal__overlay_visible')) {
        addClass(body, 'fixed');
        removeClass(header, 'z-30');
      } else {
        removeClass(body, 'fixed');
        addClass(header, 'z-30');
      }
    }

    function registerFunction() {
      const element = document.querySelector('#esc-oos-form-app.NBIS-Modal__overlay');
      if (element) {
        const observer = new MutationObserver(checkAndAddBodyClass);
        checkAndAddBodyClass();
        observer.observe(document.querySelector('#esc-oos-form-app.NBIS-Modal__overlay'), { attributes: true });
      }
    }

    const observer = new MutationObserver(registerFunction);
    registerFunction();

    if (document.getElementById('esc-oos-form')) {
      observer.observe(document.getElementById('esc-oos-form'), { childList: true, subtree: true });
    }
  })();

  function observeDOMChanges() {
    const observer = new MutationObserver(() => {
      checkForKlevuRecs();
    });

    const config = { childList: true, subtree: true };

    const targetNode = document.body;

    observer.observe(targetNode, config);
  }

  // Check for presence of klevu-recs and add hidden class if not found
  function checkForKlevuRecs() {
    const sections = [
      {
        section: miniBagYouMayAlsoLikeSection,
        id: 'mini-bag-you-may-also-like-section',
      },
      {
        section: cartYouMayAlsoLikeSection,
        id: 'cart-you-may-also-like-section',
      },
    ];

    if (!sections) return;

    sections.forEach(({ section, id }) => {
      if (section){
        const klevuRecs = section.querySelector('.klevu-recs .klevuWrap .kuRECSContainer .kuRECSWrap .kuRECSResults');

        if (!klevuRecs) {
          document.getElementById(id).classList.add('hidden');
        } else {
          document.getElementById(id).classList.remove('hidden');
        }
      }
    });
  }

  observeDOMChanges();
}

const updateCartView = async () => {
  const response = await fetch(`${Shopify.routes.root}cart?view=alt`);
  const html = await response.text();
  const element = document.createElement('div');
  element.innerHTML = html;
  document.querySelector('.min-bag-drawer').innerHTML = element.querySelector('.min-bag-drawer').innerHTML;
  document.dispatchEvent(new CustomEvent('cartUpdated'));
  document.querySelector('.sign-in-drawer').classList.remove('hidden', 'menu-opened');
};

const productWishlistIcon = document.querySelector('.product-wishlist');
if (productWishlistIcon) {
  productWishlistIcon.addEventListener('click', function () {
    this.classList.toggle('active');
  });
}

function getProductReviewCount(appkey, id) {
  fetch(`https://api-cdn.yotpo.com/v1/widget/${appkey}/products/${id}/bottomline`)
    .then((res) => res.json())
    .then((data) => {
      if (data?.response?.bottomline?.average_score > 0) {
        let productList = document.querySelectorAll(`.rating_${id}`);
        productList.forEach((product) => {
          product.innerText = Math.round(data.response.bottomline.average_score * 10) / 10;
        });
      }
    });
}

// Initialize custom JS for the first time
document.addEventListener('DOMContentLoaded', () => initializeCustomJS(false));

// Listen for custom event to reinitialize custom JS
document.addEventListener('cartUpdated', () => {
  initializeCustomJS(true);
});
